import { render, staticRenderFns } from "./dynamicPage.vue?vue&type=template&id=1c7d3ccc&scoped=true&"
import script from "./dynamicPage.vue?vue&type=script&lang=js&"
export * from "./dynamicPage.vue?vue&type=script&lang=js&"
import style0 from "./dynamicPage.vue?vue&type=style&index=0&id=1c7d3ccc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c7d3ccc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\新动态表单\\hj-dynamic-form-plugin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c7d3ccc')) {
      api.createRecord('1c7d3ccc', component.options)
    } else {
      api.reload('1c7d3ccc', component.options)
    }
    module.hot.accept("./dynamicPage.vue?vue&type=template&id=1c7d3ccc&scoped=true&", function () {
      api.rerender('1c7d3ccc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/dynamicPage.vue"
export default component.exports